module.exports = __webpack_public_path__ + "img/speech_4.3e55e211.jpeg";